import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "userReports"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "text-white" }, "No reports found.", -1)
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Reports = _resolveComponent("Reports")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_ctx.reports.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Reports, {
          class: "mb-5",
          headers: _ctx.headers,
          reports: 
        _ctx.reports.slice((_ctx.currentPage - 1) * _ctx.perPage, _ctx.currentPage * _ctx.perPage)
      
        }, null, 8, ["headers", "reports"]),
        _createVNode(_component_Pagination, {
          "aria-label": "User Reports Pagination",
          maxVisibleButtons: _ctx.visibleButtons,
          totalItems: _ctx.totalReports,
          perPage: _ctx.perPage,
          currentPage: _ctx.currentPage,
          onPageChanged: _ctx.onPageChange
        }, null, 8, ["maxVisibleButtons", "totalItems", "perPage", "currentPage", "onPageChanged"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
}